export const MANAGEMENT_MIN_WIDTH = 200;
export const REMOVE_MIN_WIDTH = 420;

export const INITIAL_OVERFLOW_SETTINGS = {
  management: false,
  remove: false,
};
